import React from "react";
import LegalMarkdown from "../components/LegalMarkdown";

export default function Terms() {
  return <LegalMarkdown src={`${process.env.PUBLIC_URL}/terms.md`} />;
}
